import React, { Component } from "react";
import sanityClient from "./client.js";
import { CommonUtil } from '../utils/CommonUtil';
import Carousel from 'react-flickity-component';
import imageUrlBuilder from "@sanity/image-url";

import '../../node_modules/flickity/dist/flickity.css';

const builder = imageUrlBuilder(sanityClient);
class AllPosts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allPostsData: [],
      allCategories: []
    }
    this.translateLang = CommonUtil.lang;
  }
  componentDidMount() {      
    this.fetchBlogs();
  }
  componentDidUpdate(prevProps) {
    if(this.translateLang !== CommonUtil.lang) {
      this.translateLang = CommonUtil.lang;
      this.fetchBlogs();      
    }
  }
  urlFor(source) {
    return builder.image(source);
  }
  fetchBlogs() {
    let lang = CommonUtil.lang.split("-")[0];
    sanityClient
      // show article if no tags  OR  has tags AND has blurlive tag
      .fetch(
        `*[_type == "post" && (length(targets[]->title) == 0 || (length(targets[]->title) >= 1 && "blurlive" in targets[]->title))]{"title":title["${lang}"],slug,publishedAt,"categories":categories[]->{title,description,_id},mainImage{asset->{_id,url}},authors[]{author->{image,name,slug}}} | order(publishedAt desc)`
    ).then((data) => {
      this.setState(c => {
        c.allPostsData = data;
        return c;
      })
    }).catch(() => {});

    sanityClient.fetch(
      `*[_type == "category"]{title,description,_id}`
    ).then((data) => {
      this.setState(c => {
        c.allCategories = data;
        return c;
      })
    }).catch(() => { });
  }
  render() {
    return (
      <div>
        <h1 className="blog-category-title">Latest</h1>
        <div className="blog-cards-container">
          <div className="blog-carousel">
            <Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: 'left', rightToLeft: false}}>
              {
                this.state.allPostsData.map((post, index) => {
                  if (!post.title || !post.slug || !post.slug.current || index > 5) {
                    return;
                  }
                  // setting blog date
                  let date = "";
                  if (post.publishedAt) {
                    date = new Date(post.publishedAt);
                    date = date.toLocaleString('default', { dateStyle: 'short' });                      
                  }
                  // set blog author
                  let author = (post.authors && post.authors.length > 0) ? post.authors[0].author : {};
                  return (
                    <a href={"/" + CommonUtil.lang + "/blog/" + post.slug.current} key={index + post.slug.current} className="blog-card-main">
                      <img src={post.mainImage ? post.mainImage.asset.url : ""} />
                      <div className="blog-card-info">
                        <div className="blog-card-title">{post.title}</div>
                      </div>
                      <div className="blog-card-footer">
                        <div className="blog-card-writer">
                          {(author) ? (
                            <a href={author.slug && author.slug.current ? "/blog/author/" + author.slug.current : ""} className="blog-card-writer-box">
                              {author.image ? 
                                (<img src={this.urlFor(author.image).width(40).url()} alt={author.name} />
                                ) : ("")}
                              <div>{author.name ? author.name : ""}</div>
                            </a>
                          ) : ("")}
                          {(date !== "") ? (
                            <div>
                              {date}
                            </div>
                          ) : ("")}
                        </div>
                      </div>
                    </a>
                  )
                })
              }
            </Carousel>
          </div>
        </div>
        {
          this.state.allCategories.map((category) => {
            //Sort out all the empty categories.
            if (!this.state.allPostsData.some(post => post.categories.some(cat => cat._id === category._id)))
              return;
            return (
              <div>
                <h1 className="blog-category-title">{category.title}</h1>
                <div className="blog-cards-container">
                  <div className="blog-carousel">
                    <Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: 'left', rightToLeft: false}}>
                      {this.state.allPostsData.map((post, index) => {
                        if (!post.title || !post.slug || !post.slug.current || !post.categories || !post.categories.some(cat => cat._id === category._id)) {
                          return;
                        }
                        // setting blog date
                        let date = "";
                        if (post.publishedAt) {
                          date = new Date(post.publishedAt);
                          date = date.toLocaleString('default', { dateStyle: 'short' });                      
                        }
                        // set blog author
                        let author = (post.authors && post.authors.length > 0) ? post.authors[0].author : {};
                        return (
                          <a href={"/" + CommonUtil.lang + "/blog/" + post.slug.current} key={index + post.slug.current} className="blog-card-main">
                            <img src={post.mainImage ? post.mainImage.asset.url : ""} />
                            <div className="blog-card-info">
                              <div className="blog-card-title">{post.title}</div>
                            </div>
                            <div className="blog-card-footer">
                            <div className="blog-card-writer">
                              {(author) ? (
                                <a href={author.slug && author.slug.current ? "/blog/author/" + author.slug.current : ""} className="blog-card-writer-box">
                                  {author.image ? 
                                    (<img src={this.urlFor(author.image).width(40).url()} alt={author.name} />
                                    ) : ("")}
                                  <div>{author.name ? author.name : ""}</div>
                                </a>
                              ) : ("")}
                              {(date !== "") ? (
                                <div>
                                  {date}
                                </div>
                              ) : ("")}
                            </div>
                            </div>
                          </a>
                        )
                      })}
                    </Carousel>
                  </div>
                </div>
              </div>
            )
           })
        }
      </div>
    )
  }
}
export default AllPosts
